        import Vue from 'vue'
        import Router from 'vue-router'

        // Containers
        import Full from '@/containers/Full'

        // Views
        import Login from '@/views/admin/Login'
        import Dashboard from '@/views/admin/Dashboard'
        import DashboardDetails from '@/views/admin/DashboardDetails'
        import Acl from '@/views/admin/Acl'
        import Translator from '@/views/admin/Translator'
        import Languages from '@/views/admin/Languages'
        import SiteProps from '@/views/admin/SiteProps'
        import EmailTemplates from '@/views/admin/EmailTemplates'
        import UserCompanies from '@/views/admin/UserCompanies'
        import Users from '@/views/admin/Users'
        import Generator from '@/views/admin/Generator'
        import WikiCategory from '@/views/admin/WikiCategory'
        import WikiTemplates from '@/views/admin/WikiTemplates'
        import WikiNew from '@/views/admin/WikiNew'
        import Wikis from '@/views/admin/Wikis'
        import Ticket from '@/views/admin/TicketWin'

        import AdminDocumentCategories from '@/views/cms/admindocumentcategories/Win'
        import DocumentCategories from '@/views/cms/documentcategories/Win'
        import Documents from '@/views/cms/documents/Win'
        import AdminDocuments from '@/views/cms/admindocuments/Win'

        import Blog from '@/views/cms/blog/Win'
        import BlogInput from '@/views/cms/blog/InputWin'

        import QuestionCategories from '@/views/cms/questioncategories/Win'
        import Question from '@/views/cms/question/Win'
        import QuestionPages from '@/views/cms/questionpages/Win'
        import QuestionMultyPages from '@/views/cms/questionpages/MultyWin'
        import GoogleForm from '@/views/googleform/Win'
        import GoogleUserForm from '@/views/googleform/UserWin'
        import GoogleUserFormAll from '@/views/googleform/UserWinAll'

        import Docs from '@/views/docs/Win'
        import AdminDocs from '@/views/docs/AdminWin'

        import Quiz from '@/views/training/quiz/Win'
        import TrainingChapters from '@/views/training/trainingchapters/Win'
        import TrainingPages from '@/views/training/trainingpages/Win'
        import QuizPages from '@/views/training/quizpages/Win'
        import ManageAnswers from '@/views/training/quizpages/MultyWin'
        import TrainingBlock from '@/views/training/trainingblock/Win'

        import Store from '@/views/salesportal/store/Win'
        import DetailsStore from '@/views/salesportal/store/DetailsWin'

        import Exam from '@/views/exam/Win'
        import ExamProgres from '@/views/exam/ExamProgres'

        import Budget from '@/views/salesportal/budget/Win'

        import HoConsolidateMonthly from '@/views/salesportal/store/storedetails/reports/HoConsolidateMonthlyWin'
        import ConsolidateMonthly from '@/views/salesportal/store/storedetails/reports/ConsolidateMonthlyWin'
        import WeeklyPerformanceSummary from '@/views/salesportal/store/storedetails/reports/WeeklyPerformanceSummaryWin'
        import WeeklyMinimumsPlanner from '@/views/salesportal/store/storedetails/reports/WeeklyMinimumsPlannerWin'
        import StoreQuarterlyMinimum from '@/views/salesportal/store/storedetails/reports/StoreQuarterlyMinimumWin'

        import TrainingBlockExam from '@/views/examnew/trainingblock/TrainingBlockWin'
        import TrainingChapterskExam from '@/views/examnew/trainingchapters/TrainingChapters'

        import Warranty from '@/views/warranty/Win'
        import StoreToStoreTransfer from '@/views/storetostore/Win.vue'
        //GENERATORLASTITEM

        const originalPush = Router.prototype.push;
        Router.prototype.push = function push(location)
        {
            return originalPush.call(this, location).catch((err) =>
            {
                if (err.name !== 'NavigationDuplicated')
                {
                    throw err;
                }
            });
        };


        Vue.use(Router)

        export default new Router(
        {
          //mode: 'hash',
          //linkActiveClass: 'open active',
          //scrollBehavior: () => ({ y: 0 }),
          routes: [
          {
            path: '/',
            name: 'HOME',
            component: Full,
            children: [
            {
              path: 'dashboard',
              name: 'DASHBOARD',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'DASHBOARD',
                component: Dashboard
              },
              {
                path: 'dashboarddetails/:blogId',
                name: 'DASHBOARDDETAILS',
                component: DashboardDetails
              }]
            }]
          },
          {
            path: '/',
            name: 'DOCS',
            component: Full,
            children: [
            {
              path: 'docs/:categoryId',
              name: 'DOCS',
              component: Docs
            }]
          },
          {
            path: '/',
            name: 'ADMINDOCS',
            component: Full,
            children: [
            {
              path: 'admindocs/:categoryId',
              name: 'ADMINDOCS',
              component: AdminDocs
            }]
          },
          {
            path: '/warranty',
            name: 'WARRANTY',
            component: Full,
            children: [
            {
              path: '',
              name: 'WARRANTY',
              component: Warranty
            }]
          },
          {
            path: '/storetostoretransfer',
            name: 'STORETOSTORETRANSFER',
            component: Full,
            children: [
            {
              path: '',
              name: 'STORETOSTORETRANSFER',
              component: StoreToStoreTransfer
            }]
          },
          {
            path: '/',
            name: 'EXAMNEW',
            component: Full,
            children: [
            {
              path: 'examnew',
              name: 'EXAMNEW',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '',
                  name: 'EXAMNEW',
                  component: TrainingBlockExam
                },
                {
                  path: 'examchapters/:trainingBlockId',
                  name: 'TRAININGCHAPTERSKEXAM',
                  component: TrainingChapterskExam
                }]
              }]
          },
          {
            path: '/exam',
            name: 'EXAM',
            component: Full,
            children: [
            {
              path: '',
              name: 'EXAM',
              component: Exam
            }]
          },
          {
            path: '/',
            name: 'GOOGLEFORM',
            component: Full,
            children: [
            {
              path: 'questionform/:questionCategoryId',
              name: 'GOOGLEFORM',
              component: GoogleForm
            }]
          },
          {
            path: '/cms',
            name: 'CMS',
            component: Full,
            children: [
            {
              path: 'blog',
              name: 'BLOG',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'BLOG',
                component: Blog
              },
              {
                path: 'bloginput/:blogId',
                name: 'BlogInput',
                component: BlogInput
              }]
            },
            {
              path: 'documents',
              name: 'DOCUMENTS',
              component: Documents
            },
            {
              path: 'admindocuments',
              name: 'ADMINDOCUMENTS',
              component: AdminDocuments
            },
            {
              path: 'admindocumentcategories',
              name: 'ADMINDOCUMENTCATEGORIES',
              component: AdminDocumentCategories
            },
            {
              path: 'documentcategories',
              name: 'DOCUMENTCATEGORIES',
              component: DocumentCategories
            },
            {
              path: 'questioncategories',
              name: 'QUESTIONCATEGORIES',
              component: QuestionCategories
            },
            {
              path: 'question/:questionCategoryId',
              name: 'QUESTION',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'QUESTION',
                component: Question
              },
              {
                path: 'questionpages/:questionFormId',
                name: 'QUESTIONPAGES',
                component: QuestionPages
              },
              {
                path: 'questionpages/:questionFormId/questionmultypages/:pageId',
                name: 'QUESTIONMULTYPAGES',
                component: QuestionMultyPages
              }]
            }]
          },
          {
            path: '/training',
            name: 'TRAINING',
            component: Full,
            children: [
            {
              path: 'trainingblock',
              name: 'TRAININGBLOCK',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'TRAININGBLOCK',
                component: TrainingBlock
              },]
            },
            {
              path: 'trainingchapters',
              name: 'TRAININGCHAPTERS',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'TRAININGCHAPTERS',
                component: TrainingChapters
              },
              {
                path: 'trainingpages/:chapterId',
                name: 'TRAININGPAGES',
                component: TrainingPages
              }]
            },
            {
              path: 'quiz',
              name: 'QUIZ',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'QUIZ',
                component: Quiz
              },
              {
                path: 'quizpages/:quizId',
                name: 'QUIZPAGES',
                component: QuizPages
              },
              {
                path: 'quizpages/manageanswers/:pageId',
                name: 'MANAGEANSWERS',
                component: ManageAnswers
              }]
            }]
          },
          {
            path: '/salesportal',
            name: 'SALESPORTAL',
            component: Full,
            children: [
            {
              path: 'store',
              name: 'STORE',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: '',
                name: 'STORE',
                component: Store
              },
              {
                path: 'storedetails/:storeId',
                name: 'STOREDETAILS',
                component:
                {
                  render(c)
                  {
                    return c('router-view')
                  }
                },
                children: [
                {
                  path: '',
                  name: 'STOREDETAILS',
                  component: DetailsStore
                },
                {
                  path: 'examprogres/:userId',
                  name: 'EXAMPROGRES',
                  component: ExamProgres
                },
                {
                  path: 'questionprogres/:userId',
                  name: 'GOOGLEUSERFORM',
                  component: GoogleUserForm
                }]
              }]
            },
            {
              path: 'budget',
              name: 'BUDGET',
              component: Budget
            },
            {
              path: 'reports',
              name: 'REPORTS',
              component:
              {
                render(c)
                {
                  return c('router-view')
                }
              },
              children: [
              {
                path: 'hoconsolidatemonthly',
                name: 'HOCONSOLIDATEMONTHLY',
                component: HoConsolidateMonthly
              },
              {
                path: 'consolidatemonthly',
                name: 'CONSOLIDATEMONTHLY',
                component: ConsolidateMonthly
              },
              {
                path: 'weeklyperformancesummary',
                name: 'WEEKLYPERFORMANCESUMMARY',
                component: WeeklyPerformanceSummary
              },
              {
                path: 'weeklyminimumsplanner',
                name: 'WEEKLYMINIMUMSPLANNER',
                component: WeeklyMinimumsPlanner
              },
              {
                path: 'storequarterlyminimum',
                name: 'STOREQUARTERLYMINIMUM',
                component: StoreQuarterlyMinimum
              }]
            }]
          },
          {
            path: '/system',
            name: 'SYSTEM',
            component: Full,
            children: [
              {
                path: 'acl',
                name: 'ACL',
                component: Acl
              },
              {
                path: 'translator',
                name: 'TRANSLATOR',
                component: Translator
              },
              {
                path: 'languages',
                name: 'LANGUAGES',
                component: Languages
              },
              {
                path: 'siteprops',
                name: 'SITEPROPS',
                component: SiteProps
              },
              {
                path: 'emailtemplates',
                name: 'EMAILTEMPLATES',
                component: EmailTemplates
              },
              {
                path: 'usercompanies',
                name: 'USERCOMPANIES',
                component: UserCompanies
              },
              {
                path: 'users',
                name: 'USERS',
                component:
                {
                  render(c)
                  {
                    return c('router-view')
                  }
                },
                children: [
                {
                  path: '',
                  name: 'USERS',
                  component: Users
                },
                {
                  path: 'examprogres/:userId',
                  name: 'EXAMPROGRES',
                  component: ExamProgres
                },
                {
                  path: 'questionprogres/:userId',
                  name: 'GOOGLEUSERFORM',
                  component: GoogleUserForm
                }]
              },
              {
                path: 'googleuserformall',
                name: 'GOOGLEUSERFORMALL',
                component: GoogleUserFormAll
              },
              {
                path: 'generator',
                name: 'GENERATOR',
                component: Generator
              }, //GENERATORINSERT
              {
                path: 'ticket',
                name: 'TICKET',
                component: Ticket
              }
            ]
          },
          {
            path: '/login',
            name: 'LOGIN',
            component: Login
          }]
        })
